import * as Icons from "@/app/(site)/_components/Atoms/Icons"
import { iconList } from "@/app/(site)/_components/GCMolecules/ButtonLinkElement/iconList"
import { toPascalCase } from "@/lib/utils"

/**
 * Maps icon values to their corresponding Icon components.
 * Used to dynamically render icons based on a string value.
 *
 * Example usage:
 *   const IconComponent = iconMap["arrow-right"];
 *   return <IconComponent />;
 */

export const iconMap: Record<string, React.ComponentType<any>> = Object.fromEntries(
    iconList.map(({ value }) => {
        const iconName = `Icon${toPascalCase(value)}`
        return [value, (Icons as any)[iconName]]
    })
)
